import React from 'react';

type ArrowDownIconProps = {
  color?: string;
};

export const ArrowDownIcon: React.FC<ArrowDownIconProps> = ({ color = '#FF154D' }) => {
  return (
    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.91836 8.16602L11.5123 0.146259H0.324377L5.91836 8.16602Z" fill={color} />
    </svg>
  );
};
